// extracted by mini-css-extract-plugin
export default {"container":"PdfHeader_container__oymmj"};